import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'
import Commerce from '../views/commerce/Commerce.vue'
import Detail from '../views/commerce/Detail.vue'
Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      redirect:'/sxy',
      meta:{
        title:'商学院-艾特企业服务平台'
      }
  },{
    path: '/sxy',
    component: Home,
    meta:{
      title:'商学院-艾特企业服务平台'
    }
  }, {
    path: '/sxy/commerce/:id',
    component: Commerce,
    meta:{
      title:'商学院-艾特企业服务平台'
    }
  }, {
    path: '/sxy/detail',
    component: Detail,
    meta:{
      title:'商学院-艾特企业服务平台'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(){return {y: 0 }},
  // base: './',
  routes
})

export default router
